import React, { useContext, useEffect } from "react";
import "../App.css";
import { useState } from "react";
import MultipleChoiceQuiz from "../components/MultipleChoiceQuiz";
import VideoPlayer from "../components/VideoPlayer";
import Header from "../components/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import LanguageSet from "../components/language/LanguageSet";
import axios from "axios";
import LanguageContext from "../components/hooks/LanguageContext";
import MatchingQuiz from "../components/MatchingQuiz";
import SingleChoiceQuizImage from "../components/SingleChoiceQuizImage";
import SingleSelectPdfImage from "../components/SingleSelectPdfImage";
import QuizMultiSelectDragDrop from "../components/QuizMultiSelectDragDrop";
import PdfShow from "../components/PdfShow";
import ImagePdfLinkComponent from "../components/ImagePdfLinkComponent";
import OtherCommingSoon from "../components/OtherCommingSoon";
import ResultOne from "../components/ResultOne";
import ResultTwo from "../components/ResultTwo";
import LoadingSnipQuiz from "../components/LoadingSnipQuiz";
import SingleChoiceQuizImageFraud from "../components/SingleChoiceQuizImageFraud";
import { ToastContainer, toast } from "react-toastify";
import Ikigai from "../components/Ikigai";
import Game from "../components/snakeLadder/Game";
import SingleSelectRadio from "../components/SingleSelectRadio";
import MultipleChoiceQuizNoImage from "../components/MultipleChoiceQuizNoImage";
import Constants from "../common/Constants";
import SatyaRakshakGame from "../components/SatyaRakshakGame";
import { useAuth } from "../providers/AuthProvider";
import BitcoinAnimation from "../components/coins/BitcoinAnimation";
import MarkButton from "./questions/MarkButton";
import PairMatchGame from "./PairMatchGame";
import FillInTheBlanks from "../components/newgame/components/FillInTheBlanks";
import { getText } from "../utils/languageUtils";

const { useRef } = React;
const API_STUDENT_PROGRESS = `${Constants.BASE_URL}/studentprogress`;

function QuestionPage() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { user, logout: authLogout, authToken, authDispatch } = useAuth(); // Use useAuth
  const [currentQuestion] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedOptionsMcq, setSelectedOptionsMcq] = useState([]);
  const { language, translations: translationData } = useContext(LanguageContext);
  const [minTime, setMinTime] = useState(null); // null = not yet set by VideoPlayer
  const [played, setPlayed] = useState(0);
  const [count, setCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingQuiz, setLoadingQuiz] = useState(false);
  const [subModule, setSubModule] = useState(null);
  const [nextSubModule, setNextSubModule] = useState(null);
  const [sectionTitle, setSectionTitle] = useState({ english: "", hindi: "" });
  const [previousSubModule, setPreviousSubModule] = useState(null);
  const [answer, setAnswer] = useState(null);
  const [isMarked, setIsMarked] = useState(0);

  const [moduleId, setModuleId] = useState(null);
  const [courseId, setCourseId] = useState(null);
  const [itemId, setItemId] = useState(null);
  const [ItemTitle, setItemTitle] = useState(null);
  const [questionTitle, setQuestionTitle] = useState(null);
  const [moduleType, setModuleType] = useState(null);
  const [nextSection, setNextSection] = useState(false);
  const [nextSectionName, setNextSectionName] = useState(null);

  const [videoBtnDisabled, setVideoBtnDisabled] = useState(true);

  // Two bucket drag and drop question
  const [rightBucket, setRightBucket] = useState([]);
  const [wrongBucket, setWrongBucket] = useState([]);

  //can you share that
  const [showResult1, setShowResult1] = useState(false);
  const [showResult2, setShowResult2] = useState(false);

  //matching question drag and drop
  const [dragDropLength, setDragDropLength] = useState(0);
  const [buckets, setBuckets] = useState([]);
  const [answerDragDrop, setAnswerDragDrop] = useState(null);

  //IKIGAI
  const [textInputs, setTextInputs] = useState([]);
  const [textInputsAns, setTextInputsAns] = useState([]);
  //pdf mark as done enable disable
  const [pdfCount, setPdfCount] = useState(0);
  const [pdfMinTime, setPdfMinTime] = useState(null); // null = not yet set by PdfShow
  const [pdfBtnDisabled, setPdfBtnDisabled] = useState(true);

  //Single Choice Quiz
  const [progress, setProgress] = useState(0);

  //snake and ladder status
  const [snakeLadderWon, setSnakeLadderWon] = useState(false);

  // const []


  const coinRefs = useRef(Array.from({ length: 15 }, () => React.createRef()));

  const questionViewStartedAtRef = useRef(null);
  const stayDurationQuestionKeyRef = useRef(null);

  // let url, title;
  let url, url2;
  if (state && state.url !== undefined && state.title !== undefined) {
    url = state.url;
    url2 = state.url2;
    // title = state.title;
  } else {
    // Handle the case where state or its properties are undefined
    // You can assign default values or show an error message here
    navigate("/home");
  }
  const [apiUrl, setApiUrl] = useState(url);



  useEffect(() => {
    const fetchData = async () => {
      const handleInvalidToken = (msg) => {
        if (msg === "Invalid Access Token") {
          authLogout();
          navigate("/");
          return true;
        }
        return false;
      };

      const setFallbackSubmodule = (summary) => {
        const {
          total_page = 1,
          next_module_url,
          previous_module_url,
          section_title,
        } = summary || {};

        setNextSubModule(next_module_url);
        setPreviousSubModule(previous_module_url);
        setTotalCount(total_page);
        setSectionTitle(section_title);

        setSubModule({
          course_module_item: [
            {
              course_id: courseId,
              module_id: "",
              id: "",
              title: { english: "", hindi: "" },
              question_type: "other",
            },
          ],
          summary: {
            next_module_url,
            previous_module_url,
            pageSize: 1,
            total: 1,
            total_page: 1,
            page_title: nextSectionName,
            section_title: { english: "", hindi: "" },
          },
        });
      };

      try {
        setLoadingQuiz(true);

        // -------- API 1: Main Data --------
        const url = `${apiUrl}&page=${currentPage}&access_token=${authToken}`;
        const { data } = await axios.get(url);
        if (handleInvalidToken(data.message)) return;

        const items = data.course_module_item;
        const summary = data.summary || {};

        setNextSubModule(summary.next_module_url);
        setPreviousSubModule(summary.previous_module_url);
        setTotalCount(summary.total_page || 1);
        setSectionTitle(summary.section_title);

        // Real module data means the synthesised thank-you screen is gone, so the
        // section jump flag must not survive. It was only ever set to true, so
        // after one thank-you screen every later "next" took the section branch
        // and navigated with whatever summary fields this module happened to have.
        setNextSection(false);

        if (items.length > 0) {
          const item = items[0];

          setSubModule(data);
          setCourseId(item.course_id);
          setModuleId(item.module_id);
          setItemId(item.id);
          setItemTitle(item.title?.english ?? "");
          setModuleType(item.question_type);

          if (
            ["single_choice", "single_choice_imag", "quiz_pdf_mcq"].includes(item.question_type)
          ) {
            setQuestionTitle(item.question_title?.english ?? "");
          }

          if (item.question_type === "drag_drop") {
            setDragDropLength(item.options?.length ?? 0);
          }

          if (item.question_type === "ikigai") {
            setTextInputs(item.question_placeholder || []);
          }
        } else {
          setFallbackSubmodule(summary);
        }

        // -------- API 2: Answer/Marked Response --------
        const subUrlQuery = apiUrl.split("?")[1];
        const newUrl2 = `${Constants.BASE_URL}/course-module-item-list-response?${subUrlQuery}&page=${currentPage}&access_token=${authToken}`;
        const { data: answerData } = await axios.post(newUrl2);
        if (handleInvalidToken(answerData.message)) return;

        const markedItems = answerData.course_module_item;
 
        if (markedItems.length > 0) {
          setAnswer(answerData);
          if (markedItems[0].question_type === "result_two" || markedItems[0].question_type === "result_one") {
            setIsMarked(1);
          }else{
             setIsMarked(markedItems[0].is_marked);
          }


          if (markedItems[0].question_type === "drag_drop") {
            setAnswerDragDrop(markedItems[0]);
          }

          if (
            markedItems[0].question_type === "ikigai" &&
            markedItems[0].marked_options
          ) {
            setTextInputsAns(markedItems[0].marked_options);
          }
        } else {
          setFallbackSubmodule(summary);
        }

        // -------- API 3: Student Progress --------
        const { data: progressData } = await axios.post(
          `${API_STUDENT_PROGRESS}?access_token=${authToken}`
        );
        if (handleInvalidToken(progressData.message)) return;

        const progressSummary = progressData.student_summary;
        setProgress(progressSummary.section_active_progress?.progress_percentage || 0);
        authDispatch({
          type: "SET_PROGRESS",
          payload: {
            points: progressSummary.points,
            progress: progressSummary,
          },
        });

        // -------- API 4: Course Progress --------
        const { data: courseData } = await axios.post(`${url2}&access_token=${authToken}`);
        if (handleInvalidToken(courseData.message)) return;
        setProgress(courseData.course_summary?.progress ?? 0);

      } catch (error) {
        console.error(error);
        toast.error(error?.message);
      } finally {
        setLoadingQuiz(false);
      }
    };

    fetchData();
  }, [currentPage, apiUrl, navigate, authToken, url2]);
  // Include all dependencies in the array

  useEffect(() => {
    if (loadingQuiz) return;
    if (itemId === null || itemId === undefined || itemId === "") return;
    const key = `${apiUrl}|${currentPage}|${itemId}`;
    if (stayDurationQuestionKeyRef.current !== key) {
      stayDurationQuestionKeyRef.current = key;
      questionViewStartedAtRef.current = Date.now();
    }
  }, [loadingQuiz, itemId, currentPage, apiUrl]);

  // Section position is derived from the course the student is actually in, instead
  // of from hardcoded course ids or English section names. Courses 1-4 are the
  // below-18 sections and 5-8 the above-18 equivalents, so the 4th section of either
  // group is the last one and leads into the endline.
  const sectionIndexOf = (id) => (Number(id) ? ((Number(id) - 1) % 4) + 1 : null);
  const isFinalSection = (id) => sectionIndexOf(id) === 4;

  const getStayDurationSeconds = () => {
    const start = questionViewStartedAtRef.current;
    if (start == null) return 0;
    return Math.max(0, Math.round((Date.now() - start) / 1000));
  };

  const handleOptionSelect = (optionIndex, question_type) => {
    switch (question_type) {
      case "single_choice":
        setSelectedOptions([optionIndex]);
        break;
      case "mcq":
        setSelectedOptionsMcq((prevOptions) =>
          prevOptions.includes(optionIndex)
            ? prevOptions.filter((index) => index !== optionIndex)
            : [...prevOptions, optionIndex]
        );
        break;
      default:
        break;
    }
  };

  const ResetResponse = () => {
    setSelectedOptions([]);
  };

  const handlePreviousClick = () => {
    // Reset state
    setMinTime(null); // Reset to null, not 0
    setPlayed(0);
    setCount(1);
    setVideoBtnDisabled(true);

    setPdfCount(0);
    setPdfMinTime(null); // Reset to null, not 0
    setPdfBtnDisabled(true);

    setSelectedOptions({});
    setSelectedOptionsMcq([]);
    // The next question may be a different type whose answer has a different
    // shape, so the previous question's answer must not survive the navigation.
    setAnswer(null);
    setIsMarked(0);

    // Handle previous navigation
    if (previousSubModule === null) {
      navigate(-1);
      return;
    }

    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    } else {
      setApiUrl(previousSubModule);
      setCurrentPage(1);
    }
  };


  const resetPdfState = () => {
    setPdfCount(0);
    setPdfMinTime(null); // Reset to null, not 0
    setPdfBtnDisabled(true);
  };

  // options.keepMarked leaves isMarked alone. It is used when the navigation is
  // triggered by a mark that has just succeeded: clearing the flag on the way out
  // and then failing to load the destination (the fetch below only toasts and
  // clears the loader, leaving the previous question still rendered) left a
  // question that IS marked on the server showing an unmarked button. Bound as an
  // onClick in the JSX too, so this receives an event there - only an explicit
  // { keepMarked: true } from a caller keeps the flag.
  const handleNextClick = (options = {}) => {
    // Reset video, PDF, and option-related states
    setMinTime(null); // Reset to null, not 0
    setPlayed(0);
    setCount(1);
    setVideoBtnDisabled(true);
    setPdfCount(0);
    setPdfMinTime(null); // Reset to null, not 0
    setPdfBtnDisabled(true);
    setSelectedOptions({});
    setSelectedOptionsMcq([]);
    // The next question may be a different type whose answer has a different
    // shape, so the previous question's answer must not survive the navigation.
    setAnswer(null);
    if (options?.keepMarked !== true) {
      setIsMarked(0);
    }

    const moduleTitle = subModule.course_module_item?.[0]?.title?.english || "";
    const sectionTitle = subModule.summary?.section_title?.english || "";
    const nextSectionName = subModule.summary?.next_section_name || "";

    // Map of (section, module) combinations that require 80% progress
    const restrictedCombinations = [
      { section: "Digital Safety", module: "Security vs Privacy " },
      { section: "Digital Well-Being", module: "Mental Health Helplines" },
      { section: "Digital Information Ecosystem", module: "Internet behing the scenes" },
      { section: "Digital Agency", module: "Satyarakshak Game" },
    ];

    const needsProgressCheck = restrictedCombinations.some(
      ({ section, module }) => sectionTitle === section && moduleTitle === module
    );

    if (progress < 80 && needsProgressCheck) {  //endline make 0 to 80
      navigate(-1);
      return;
    }

    // Handle nextSectionName routing
    if (nextSection) {
      const nextSectionMap = {
        "Digital Well-Being": "/module/digital-wellbeing",
        "Digital Information Ecosystem": "/module/digital-infoecosystem",
        "Digital Agency": "/module/digital-agency",
      };

      // Fall back to home when the next section has no dedicated route, so an
      // unrecognised section name can never leave the student on a dead screen.
      const path = nextSectionMap[nextSectionName] || "/";
      navigate(path, {
        state: {
          url: subModule.summary?.next_module_url,
          page_title: subModule.summary?.page_title,
        },
      });
      return;
    }

    // The course id comes from the module being viewed rather than from its English
    // section name, so the above-18 courses (5-8) are not mistaken for the below-18
    // ones (1-4) which share the same section titles.
    const courseId = Number(subModule.course_module_item?.[0]?.course_id) || null;

    if (nextSubModule === null && courseId && currentPage === totalCount) {
      setNextSectionAndNavigate(nextSectionName, courseId);
      return;
    }

    // Navigate within the current module
    if (currentPage < totalCount) {
      setCurrentPage(currentPage + 1);
    } else {
      setApiUrlAndNavigate(nextSubModule, 1);
    }
  };


  const setNextSectionAndNavigate = (nextSectionName, courseId) => {
    if (isFinalSection(courseId)) {
      navigate("/endline");
      return;
    }

    const thankYouItem = {
      course_id: courseId,
      module_id: "",
      id: "",
      title: { english: "", hindi: "" },
      question_type: "thank_you",
    };

    const summary = subModule?.summary || {};

    setSubModule({
      course_module_item: [thankYouItem],
      summary: {
        next_module_url: summary.next_section_url,
        previous_module_url: summary.current_module_url,
        pageSize: 1,
        total: 1,
        total_page: 1,
        page_title: nextSectionName,
      },
    });

    // A thank you screen has nothing to complete, so it is already satisfied - the
    // same treatment result_one / result_two get when they come back from the API.
    // Without this the arrow beside it is inert: its onClick collapses to undefined
    // while isMarked is 0, and being a div, the disabled prop cannot show that.
    // handleNextClick set isMarked to 0 just before calling this, so the later
    // write is the one that survives the batch.
    setIsMarked(1);

    setNextSection(true);
    setNextSectionName(nextSectionName);
  };

  const setApiUrlAndNavigate = (url, page) => {
    setApiUrl(url);
    setCurrentPage(page);
  };

  const buildParams = (extraParams = {}) => {
    const baseParams = {
      course_id: courseId,
      module_id: moduleId,
      item_id: itemId,
      module_type: moduleType,
      access_token: authToken,
      item_title: ItemTitle,
      ...extraParams
    };

    return Object.entries(baseParams)
      .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
      .join("&");
  };

  const handleSuccess = (response, type) => {
    const data = response?.data;
    const item = data?.course_module_item?.[0];

    if (data?.message === "Invalid Access Token") {
      authLogout();
      navigate("/");
      return;
    }

    if (!item) return;

    setIsMarked(item.is_marked);

    if (type === "drag_drop") {
      setAnswerDragDrop(item);
    } else if (
      [
        "single_choice",
        "quiz_pdf_mcq",
        "single_choice_image",
        "single_select_radio",
        "mcq",
        "multi_select_radio",
        "quiz_pdf_drag_drop",
        "ikigai",
        "imagemap",
        "snake_and_ladder",
        "satyarakshak_game",
        "match_card_pair_game",
        "fill_in_the_blanks_single"
      ].includes(type)
    ) {
      setAnswer(data);
    }

    if (type === "ikigai") {
      setTextInputsAns(item.marked_options);
    }

    // Skip coin animation if imagemap is not the last page
    if (type === "imagemap" && currentPage !== totalCount) {
      setLoading(false);
      return;
    }

    const isCorrect =
      item.correct_option?.id &&
      item.option_marked?.id &&
      Number(item.correct_option.id) === Number(item.option_marked.id);

    const shouldAnimate =
      type !== "satyarakshak_game" &&
      (
        ["quiz_pdf_mcq", "single_choice_image", "single_select_radio"].includes(type)
          ? isCorrect
          : true
      );

    if (shouldAnimate) {
      CoinAnimate(item.points);
      ShowMyPoints();
    }

    setLoading(false);

    // For the last imagemap page, navigate after marking as done. Keep the mark:
    // setIsMarked(1) above and a reset here land in the same React batch, so the
    // reset won, and the question showed as unmarked whenever the destination
    // failed to load and left this screen on display.
    if (type === "imagemap" && currentPage === totalCount) {
      handleNextClick({ keepMarked: true });
    }
  };



  const handleError = (err) => {
    console.error(err);
    toast.error(err?.message || "Something went wrong");
    setLoading(false);
  };

  const MarkAsDoneQuiz = (type) => {
    const config = {
      video: {},
      pdf: {},
      imagemap: {},
      single_choice: {
        item_title: questionTitle,
        option_id: selectedOptions?.id,
        option_title: selectedOptions?.title,
      },
      single_choice_image: {
        item_title: questionTitle,
        option_id: selectedOptions?.id,
        option_title: selectedOptions?.title?.english,
      },
      single_select_radio: {
        item_title: questionTitle,
        option_id: selectedOptions?.id,
        option_title: selectedOptions?.title?.english,
      },
      fill_in_the_blanks_single: {
        item_title: questionTitle,
        option_id: selectedOptions?.id,
        option_title: selectedOptions?.title?.english,
      },
      mcq: {
        options: selectedOptionsMcq?.toString(),
      },
      multi_select_radio: {
        options: selectedOptionsMcq?.toString(),
      },
      quiz_pdf_mcq: {
        item_title: questionTitle,
        option_id: selectedOptions?.id,
        option_title: selectedOptions?.title,
      },
      quiz_pdf_drag_drop: {},
      drag_drop: {},
      ikigai: {
        placeholders: JSON.stringify(textInputs),
      },
      snake_and_ladder: {},
      satyarakshak_game: {},
      match_card_pair_game: {}
    };

    const extraParams = config[type];
    if (extraParams === undefined) return;

    const queryString = buildParams({
      course_id: courseId,
      module_id: moduleId,
      item_id: itemId,
      item_title: ItemTitle,
      module_type: moduleType,
      access_token: authToken,
      ...extraParams,
      stay_duration: getStayDurationSeconds(),
    });

    const url = `${Constants.BASE_URL}/course-module-item-markasdone?${queryString}`;

    setLoading(true);

    axios
      .post(url)
      .then((res) => handleSuccess(res, type))
      .catch((err) => {
        console.error(err);
        toast.error(err?.message);
        setLoading(false);
      });
  };

  const CoinAnimate = (count) => {
    if (count <= 0) return;

    const ref = coinRefs.current[count - 1];
    if (ref?.current?.addCoin) {
      ref.current.addCoin(count);
    }
  };


  const ShowMyPoints = async () => {
    try {
      const { data } = await axios.post(
        `${API_STUDENT_PROGRESS}?access_token=${authToken}`
      );

      if (data.message === "Invalid Access Token") {
        authLogout();
        navigate("/");
        return;
      }

      const studentSummary = data.student_summary;

      setProgress(studentSummary.section_active_progress?.progress_percentage || 0);

      authDispatch({
        type: "SET_PROGRESS",
        payload: {
          points: studentSummary.points,
          progress: studentSummary,
        },
      });

    } catch (error) {
      console.error("Error fetching student progress:", error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  // Video unlock: time spent on this question's screen, read from the timestamp
  // that questionViewStartedAtRef already keeps (the same value sent to the API as
  // stay_duration) rather than from an accumulating counter.
  //
  // The counter this replaces was incremented off the rounded playback position,
  // which could only ever fall behind and never catch up: a buffering stall or a
  // dropped progress tick lost counts permanently, and a position that moved by
  // more than a second still counted once. So a student could watch past the
  // minimum and still be short of minTime, while a reload got a clean run and
  // worked - the intermittent behaviour that was reported. A timestamp cannot
  // drift behind, be double counted, or survive into the next question, which is
  // what any shared running total is exposed to.
  //
  // minTime is only ever set by VideoPlayer and is reset to null on every
  // navigation, so a non-null minTime is what marks this as a video question.
  const stayDurationKey = `${apiUrl}|${currentPage}|${itemId}`;

  useEffect(() => {
    if (minTime === null) {
      setVideoBtnDisabled(true);
      return;
    }

    const evaluate = () => {
      // Only trust the clock once it has been stamped for THIS question. Before
      // that it still holds the previous question's start time, which would read
      // as a long stay and unlock the button the moment the screen appeared.
      if (stayDurationQuestionKeyRef.current !== stayDurationKey) {
        setVideoBtnDisabled(true);
        return;
      }
      setVideoBtnDisabled(getStayDurationSeconds() < minTime);
    };

    evaluate();
    const interval = setInterval(evaluate, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [minTime, stayDurationKey]);

  useEffect(() => {
    pdfDisabled();
  }, [pdfCount, pdfMinTime, isMarked]);

  const pdfDisabled = () => {
    // Keep disabled if pdfMinTime hasn't been set yet (still null)
    // Enable when pdfMinTime is set AND pdfCount has reached pdfMinTime
    if (pdfMinTime !== null && pdfCount >= pdfMinTime) {
      setPdfBtnDisabled(false);
    } else if (isMarked === 1) {
      setPdfBtnDisabled(true);
    } else {
      setPdfBtnDisabled(true);
    }
  };


  const renderThankYou = (courseId, language) => {
    const imageMap = {
      1: {
        english: "thankyou1.png",
        hindi: "thankyou2.png",
        kannada: "thankyou1.png",
      },
      2: {
        english: "section2/thankyou1.png",
        hindi: "section2/thankyou2.png",
        kannada: "section2/thankyou1.png",
      },
      3: {
        english: "section3/thankyou1.png",
        hindi: "section3/thankyou2.png",
        kannada: "section3/thankyou1.png",
      },
      4: {
        english: "section4/thankyou1.png",
        hindi: "section4/thankyou2.png",
        kannada: "section4/thankyou1.png",
      },
    };

    const navigationMap = {
      4: "/endline",
      default: "/myprogress",
    };

    // Both age groups share the same four section assets and end-of-section routing.
    const sectionKey = sectionIndexOf(courseId);
    const imageSrc = imageMap[sectionKey]?.[language];
    const navigateTo = navigationMap[sectionKey] || navigationMap.default;

    if (!imageSrc) return null;

    return (
      <div className="row">
        <div className="col-12">
          <div className="thanksmsg my-4" onClick={() => navigate(navigateTo)}>
            <img src={require(`../assets/images/${imageSrc}`)} alt="" width="100%" />
          </div>
        </div>
      </div>
    );
  };



  const renderQuestion = (question) => {
    const { question_type, course_id } = question;

    const sharedProps = {
      question,
      language,
      answer,
      isMarked,
    };

    const questionTypeMap = {
      video: (
        <VideoPlayer
          key={question.id} // Force remount when question changes
          {...sharedProps}
          setMinTime={setMinTime}
          setPlayed={setPlayed}
          setCount={setCount}
          count={count}
          played={played}
        />
      ),
      pdf: (
        <PdfShow
          key={question.id} // Force remount when question changes
          {...sharedProps}
          setPdfCount={setPdfCount}
          setPdfMinTime={setPdfMinTime}
          pdfCount={pdfCount}
        />
      ),
      imagemap: (
        <ImagePdfLinkComponent
          {...sharedProps}
          selectedOptions={selectedOptions}
          handleNextClick={handleNextClick}
          MarkAsDoneQuiz={MarkAsDoneQuiz}
          currentPage={currentPage}
          totalCount={totalCount}
        />
      ),
      single_choice: (
        <SingleChoiceQuizImage
          {...sharedProps}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
          handleOptionSelect={handleOptionSelect}
          ResetResponse={ResetResponse}
        />
      ),
      single_choice_image: (
        <SingleChoiceQuizImageFraud
          {...sharedProps}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
          handleOptionSelect={handleOptionSelect}
          ResetResponse={ResetResponse}
        />
      ),
      single_select_radio: (
        <SingleSelectRadio
          {...sharedProps}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
          handleOptionSelect={handleOptionSelect}
          ResetResponse={ResetResponse}
        />
      ),
      mcq: (
        <MultipleChoiceQuiz
          {...sharedProps}
          selectedOptionsMcq={selectedOptionsMcq}
          setSelectedOptionsMcq={setSelectedOptionsMcq}
          handleOptionSelect={handleOptionSelect}
        />
      ),
      multi_select_radio: (
        <MultipleChoiceQuizNoImage
          {...sharedProps}
          selectedOptionsMcq={selectedOptionsMcq}
          setSelectedOptionsMcq={setSelectedOptionsMcq}
          handleOptionSelect={handleOptionSelect}
        />
      ),
      drag_drop: (
        <MatchingQuiz
          {...sharedProps}
          setBuckets={setBuckets}
          buckets={buckets ?? []}
          answerDragDrop={answerDragDrop}
        />
      ),
      quiz_pdf_mcq: (
        <SingleSelectPdfImage
          {...sharedProps}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
          handleOptionSelect={handleOptionSelect}
          ResetResponse={ResetResponse}
        />
      ),
      quiz_pdf_drag_drop: (
        <QuizMultiSelectDragDrop
          {...sharedProps}
          rightBucket={rightBucket}
          setRightBucket={setRightBucket}
          wrongBucket={wrongBucket}
          setWrongBucket={setWrongBucket}
        />
      ),
      other: <OtherCommingSoon question={question} />,
      result_one: (
        <ResultOne
          {...sharedProps}
          showResult1={showResult1}
          setShowResult1={setShowResult1}
        />
      ),
      result_two: (
        <ResultTwo
          {...sharedProps}
          showResult2={showResult2}
          setShowResult2={setShowResult2}
        />
      ),
      ikigai: (
        <Ikigai
          key={question.id}
          {...sharedProps}
          setTextInputs={setTextInputs}
          textInputs={textInputs}
          textInputsAns={textInputsAns}
          setTextInputsAns={setTextInputsAns}
        />
      ),
      snake_and_ladder: (
        <Game
          {...sharedProps}
          onStateChange={setSnakeLadderWon}
          translations={translationData}
        />
      ),
      match_card_pair_game: (
        <PairMatchGame
          {...sharedProps}
        />
      ),
      fill_in_the_blanks_single: (
        <FillInTheBlanks
          {...sharedProps}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
          handleOptionSelect={handleOptionSelect}
          ResetResponse={ResetResponse}
        />
      ),
      satyarakshak_game: <SatyaRakshakGame question={question} language={language} />,
      thank_you: renderThankYou(Number(course_id), language),
    };

    return questionTypeMap[question_type] || null;
  };



  const CheckIkagiValues = () => {
    const allTextHaveValue = textInputs.every(
      (item) => item.text && item.text.trim() !== ""
    );

    return allTextHaveValue;
  };

  return (
    <div id="body_bg">
      <Header page_title={getText(sectionTitle, language)} />
      <LanguageSet />
      {loadingQuiz && <LoadingSnipQuiz />}
      <>
        <div className="container-fluid px-0">
          <div className="row justify-content-center">
            <div className="col-xxl-5 col-xl-7 col-lg-8 col-md-12">
              {subModule && (
                  <section className="my-3">
                    <div className="container-fluid">
                      <>
                        {/* {loadingQuiz ? <LoadingSnipQuiz /> : renderQuestion(subModule.course_module_item[currentQuestion])} */}
                        {renderQuestion(
                          subModule.course_module_item[currentQuestion]
                        )}
                        <div className="row">
                          <div className="col-12">
                            <div className="mark-buttons d-flex justify-content-between">
                              <div className="left-btn">
                                {" "}
                                <div
                                  onClick={handlePreviousClick}
                                  disabled={currentQuestion === 0}
                                  className="previous_btn"
                                >
                                  <FontAwesomeIcon
                                    icon={faArrowLeft}
                                    size="lg"
                                    color="#fff"
                                  />
                                </div>
                              </div>
                              <MarkButton
                                question={subModule.course_module_item[currentQuestion]}
                                isMarked={isMarked}
                                loading={loading}
                                language={language}
                                videoBtnDisabled={videoBtnDisabled}
                                pdfBtnDisabled={pdfBtnDisabled}
                                selectedOptions={selectedOptions}
                                selectedOptionsMcq={selectedOptionsMcq}
                                CheckIkagiValues={CheckIkagiValues}
                                snakeLadderWon={snakeLadderWon}
                                wrongBucket={wrongBucket}
                                rightBucket={rightBucket}
                                buckets={buckets}
                                dragDropLength={dragDropLength}
                                currentPage={currentPage}
                                totalCount={totalCount}
                                setShowResult1={setShowResult1}
                                setShowResult2={setShowResult2}
                                MarkAsDoneQuiz={MarkAsDoneQuiz}
                                translationData={translationData}
                              />
                              <div className="right-btn">
                                <div
                                  className="previous_btn"
                                  onClick={
                                    isMarked === 0
                                      ? undefined
                                      : subModule.course_module_item[currentQuestion].question_type === "thank_you" &&
                                        !isFinalSection(subModule.course_module_item[currentQuestion].course_id)
                                        ? () => navigate("/myprogress")
                                        : subModule.course_module_item[currentQuestion].question_type === "thank_you" &&
                                          isFinalSection(subModule.course_module_item[currentQuestion].course_id)
                                          ? () => navigate("/endline")
                                          : handleNextClick
                                  }
                                  disabled={isMarked === 0}
                                >
                                  <FontAwesomeIcon
                                    icon={faArrowRight}
                                    size="lg"
                                    color="#fff"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    </div>
                  </section>
                )}
              </div>
            </div>
          </div>
          {coinRefs.current.map((ref, index) => {
            return (
              <BitcoinAnimation key={index} ref={ref} />
            )
          })}

        </>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default QuestionPage;
